import {darken, hideVisually} from 'polished';
import styled, {css} from 'styled-components';

import {colors, transition} from '@app/styles/theme';

export const Root = styled.label<{hasLabel: boolean; disabled: boolean; isList: boolean}>`
    display: ${(p) => (p.hasLabel ? 'flex' : 'inline-flex')};
    align-items: center;
    cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};

    ${(p) =>
        p.isList &&
        `
        width: 100%;
        flex-direction: row-reverse;
        justify-content: space-between;
    `}
`;

export const NativeInput = styled.input`
    ${hideVisually()};
`;

export const Indicator = styled.span<{
    checked: boolean;
    disabled?: boolean;
    sizes?: {width: number; height: number};
}>`
    position: relative;
    flex-shrink: 0;
    width: ${(p) => (p.sizes ? `${p.sizes.width}px` : '18px')};
    height: ${(p) => (p.sizes ? `${p.sizes.height}px` : '18px')};
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: ${colors.brandPrimary};
    background-color: ${(p) => (p.checked ? colors.brandPrimary : colors.transparent)};
    transition: all ${transition.duration};

    ${(p) =>
        p.checked &&
        css`
            &::after {
                content: '';
                position: absolute;
                top: 2px;
                left: 2px;
                width: ${p.sizes ? `${Math.round(p.sizes.width / 2.3)}px` : '10px'};
                height: ${p.sizes ? `${Math.round(p.sizes.width / 6)}px` : '5px'};
                border-width: 2px;
                border-style: solid;
                border-color: #fff;
                border-top-color: transparent;
                border-right-color: transparent;
                transform: rotate(-45deg);
            }
        `}
    
    ${(p) =>
        p.disabled &&
        css`
            border-color: ${colors.textMuted};
            background-color: ${p.checked ? colors.textMuted : colors.transparent};
        `}

    ${NativeInput}:focus:not(.focus-visible) ~ & {
        box-shadow: 0 0 0 1px ${darken(0.4, colors.brandPrimary)};
    }

    ${NativeInput}:focus:not(:focus-visible) ~ & {
        box-shadow: none;
    }
`;

export const Label = styled.span<{disabled?: boolean; isList: boolean}>`
    user-select: none;
    margin-left: ${(p) => (p.isList ? '0' : '10px')};
    opacity: ${(p) => (p.disabled ? 0.5 : 1)};
`;
